// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {postStatusChangeRequest} from '../../shared/repositories';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const createStatusChangeRequest = () =>
    async (dispatch, getState) => {

        const state = getState();
        const postRequestObject = {
            comments: state.statusChange.statusChangeRequest.comments,
            commentsToDealer: state.statusChange.statusChangeRequest.commentsToDealer,
            createdBy: state.statusChange.statusChangeRequest.createdBy,
            createdDate: state.statusChange.statusChangeRequest.createdDate,
            damageDesc: state.statusChange.statusChangeRequest.damageDesc,
            damageEventDate: state.statusChange.statusChangeRequest.damageEventDate,
            damageEventDesc: state.statusChange.statusChangeRequest.damageEventDesc,
            file: state.statusChange.statusChangeRequest.file,
            id: 0,
            internalDeereComments: state.statusChange.statusChangeRequest.internalDeereComments,
            lastContactDetails: state.statusChange.statusChangeRequest.lastContactDetails,
            lawEnforcementDetails: state.statusChange.statusChangeRequest.lawEnforcementDetails,
            machinePutBack: state.statusChange.statusChangeRequest.machinePutBack,
            machineStatusUpdateRequestForm: state.statusChange.statusChangeRequest.machineStatusUpdateRequestForm,
            newStatus: state.statusChange.statusChangeRequest.newStatus,
            product: state.statusChange.statusChangeRequest.product,
            status: 'NEW',
            territory: state.statusChange.statusChangeRequest.territory
        };

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await postStatusChangeRequest(postRequestObject);

            successAlertBar(translate('STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY'));

            dispatch(routerActions.goBack());

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/status-change-request/action-creators/status-change-request.js